<template>
  <div class="table-responsive" ref="scroll" @wheel.passive="autoScroll">
    <!--
    <table class="table table-sm " ref="table">
      <thead class="table-danger">
      <tr>
        <th v-for="(field, index) in fields" :key="index" style="position: sticky; top: 0; background-color: white;"
            v-show="field.key === 'allHipassFare' ? isShowHipassFare :
            (field.key === 'allAddFare' ? isShowAddFare :
            (field.key === 'allFare' ? isShowTotalFare : true))"
        >
          {{ field.label }}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(element, idx) in elements" :key=idx>
        <td>{{ typeList[element.payType] }}</td>
        <td>{{ element.allPayfare ? insertComma(element.allPayfare) : element.allPayfare }}원</td>
        <td>{{ element.allCallFare ? insertComma(element.allCallFare) : element.allCallFare }}원</td>
        <td v-show="isShowHipassFare">{{ element.allHipassFare ? insertComma(element.allHipassFare) : element.allHipassFare}}원</td>
        <td v-show="isShowAddFare">{{ element.allAddFare ? insertComma(element.allAddFare) : element.allAddFare}}원</td>
        <td v-show="isShowTotalFare">{{ element.allFare ? insertComma(element.allFare) : element.allFare }}원</td>
        <td>{{ element.allPayCount ? insertComma(element.allPayCount) : element.allPayCount }}건</td>
      </tr>
      </tbody>
    </table>
    -->

    <table class="table table-sm " ref="table">
      <thead class="table-danger">
      <tr>
        <th>결제타입별 금액</th>
        <th v-for="(head, index) in showlist" :key=index>{{head}}</th>    
      </tr>
      </thead>
      <tbody >
        <tr>
          <td>총 미터금액</td>
        <td v-for="(element, idx) in elements" :key=idx>{{ element.allPayfare ? insertComma(element.allPayfare) : element.allPayfare }}원</td>
        </tr>
        <tr v-show="isShowHipassFare">
          <td >총 통행요금</td>
        <td v-for="(element, idx) in elements" :key=idx>{{ element.allHipassFare ? insertComma(element.allHipassFare) : element.allHipassFare }}원</td>
        </tr>
        <tr v-show="isShowAddFare">
          <td>총 추가금액</td>
        <td v-for="(element, idx) in elements" :key=idx>{{ element.allAddFare ? insertComma(element.allAddFare) : element.allAddFare }}원</td>
        </tr>
        <tr v-show="isShowTotalFare">
          <td>총 합계금액</td>
        <td v-for="(element, idx) in elements" :key=idx>{{ element.allFare ? insertComma(element.allFare) : element.allFare }}원</td>
        </tr>
        <tr>
          <td>총 결제건수</td>
        <td v-for="(element, idx) in elements" :key=idx>{{ element.allPayCount ? insertComma(element.allPayCount) : element.allPayCount }}건</td>
        </tr>
      
      </tbody> 
    </table> 
  </div>  
</template>

<script setup>
import {ref, defineProps, defineExpose, onMounted, watch} from "vue";
import tachoEntity from "@/entity/TachoEntity";
import { insertComma } from "@/components/tacho/common/CommonFunc"

const isShowHipassFare = ref(true)
const isShowAddFare = ref(true)
const isShowTotalFare = ref(true)
const showlist = ref([])

const props = defineProps({
  fields: Object,
  elements: Object,
  selectAutoScroll: Function,
  onSelected: Function,
  onDoubleClick: Function
})

const scroll = ref("");
const typeList = tachoEntity.paymentTypeEnum;

watch(()=>props.elements, (_new, _odd)=>{

  showlist.value = [];

  for( let i = 0 ; i < _new.length ; i++ ) {
    showlist.value.push(typeList[_new[i].payType]);
  }

})

defineExpose({isShowHipassFare, isShowAddFare, isShowTotalFare});
  
  
  const autoScroll = () => (props.selectAutoScroll !== undefined && scroll.value.scrollHeight - scroll.value.scrollTop <= scroll.value.clientHeight) ? props.selectAutoScroll() : "";
  
</script>

<style scoped>
* {
  font-size: 0.8rem;
}
th {
  background-color: #e3e3e3 !important;
  border-color: #c9c8c8 !important;
  width: 6rem;
  font-weight: 500;
  border-top: 1px solid black;
  
}
td {
  border-top: 1px solid black;
  font-weight: 500;
  width: 10rem;
}
tr :first-child {
  background-color: #e3e3e3 !important;
  border-color: #c9c8c8 !important;
  
}
.last-tr {
  border-bottom: 1px solid #c9c8c8;
}
</style>